import { applyOptimizeVariation } from '../consts/actionTypes';
import { readCookie } from '../helpers/cookie';

export enum ActiveTestNames {
    bookingFunnel = 'bookingFunnel',
    allInclusivePrices = 'allInclusivePrices',
    newDurationFilter = 'newDurationFilter',
}

export type ActiveTest = {
    name: ActiveTestNames;
    testId: string;
    testGroup: number;
} & {
    [key: string]: unknown;
};

const activeTests = [
    {
        name: ActiveTestNames.bookingFunnel,
        testId: 'joxu_UDxQaG2WEqfeLwUtQ',
        newBookingFlow: 1,
    },
    {
        name: ActiveTestNames.allInclusivePrices,
        testId: 'uzDc5bLrTJqjRdo5gFifzQ',
        allInPricesGroup: 1,
    },
    {
        name: ActiveTestNames.newDurationFilter,
        testId: '2DVtXGrIRr6EmWITQq7G2w',
        newDurationFilterGroup: 1,
    },
];

export const initOptimizeTests: any = () => (dispatch) => {
    const activeTestData = activeTests.map((testData) => {
        const cookieValue = JSON.parse(readCookie('override_test') || '{}');

        const optimizeTestGroup = (window as any)?.google_optimize?.get(testData.testId);
        const overridenTestGroup = cookieValue?.[testData.testId];

        const testGroup = overridenTestGroup !== undefined ? overridenTestGroup : optimizeTestGroup;
        return {
            ...testData,
            testGroup: Number.parseInt(testGroup, 10),
        };
    });

    dispatch(setOptimizeTestsVariation(activeTestData));
};

const setOptimizeTestsVariation = (activeTestData: ActiveTest[]) => ({
    type: applyOptimizeVariation,
    payload: activeTestData,
});
